export default __webpack_public_path__ + "static/media/chicken-purple.1a5f2a90.svg";